exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inner-270eef26{margin:20px}.header-5365225b{color:#616161}.text-70b3c650{margin:8px 0 10px 0}\n", ""]);

// Exports
exports.locals = {
	"inner": "inner-270eef26",
	"header": "header-5365225b",
	"text": "text-70b3c650"
};